import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/ChevronRightIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M8.29302 5.29302C8.68354 4.90249 9.31655 4.90249 9.70708 5.29302L15.7071 11.293C16.0976 11.6835 16.0976 12.3166 15.7071 12.7071L9.70708 18.7071C9.31655 19.0976 8.68354 19.0976 8.29302 18.7071C7.90249 18.3166 7.90249 17.6835 8.29302 17.293L13.586 12L8.29302 6.70708C7.90249 6.31655 7.90249 5.68354 8.29302 5.29302Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M5.46979 3.46979C5.76269 3.1769 6.23745 3.1769 6.53034 3.46979L10.5303 7.46979C10.8232 7.76269 10.8232 8.23746 10.5303 8.53034L6.53034 12.5303C6.23746 12.8232 5.76269 12.8232 5.46979 12.5303C5.1769 12.2374 5.1769 11.7627 5.46979 11.4698L8.93952 8.00007L5.46979 4.53034C5.1769 4.23745 5.1769 3.76269 5.46979 3.46979Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as ChevronRightIcon };
